import { ArrowDownOutlined, ArrowUpOutlined } from "@ant-design/icons";

interface DifferenceCellProps {
    percent: number,
}
export const DifferenceCell: React.FC<DifferenceCellProps> = ({percent}) => {
    let color = "green"
    let icon = <ArrowUpOutlined />
    if (percent < 0) {
        icon = <ArrowDownOutlined />
        color = "red";
    }
    percent = Math.floor(percent*100)/100
    const warning = Math.abs(percent) >= 50;
    return <div className="flex flex-col items-center px-2 py-2" style={{color: color}}>
        <div className="flex flex-row justify-between w-[60px]">
            {icon}
            <p className="ml-2">{percent}%</p>
        </div>
        {warning?<div className="rounded bg-red-600 px-2 py-[1px] text-white mt-1">Cảnh báo</div>:null}
    </div>
}